// extracted by mini-css-extract-plugin
export default {"button":"_2_A-G"};